const getVariantData = (variant, variantsData) => {
  if (!variantsData) return null;
  if (!variant)
    return variantsData.find(({ variantId }) => variantId === 'printed') || variantsData[0];
  return variantsData.find(({ variantId }) => variantId === variant) || variantsData[0];
};

export { getVariantData };
